import { render, staticRenderFns } from "./WorkspaceAreaCenter.vue?vue&type=template&id=82b7b882&scoped=true&"
import script from "./WorkspaceAreaCenter.vue?vue&type=script&lang=js&"
export * from "./WorkspaceAreaCenter.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceAreaCenter.vue?vue&type=style&index=0&id=82b7b882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b7b882",
  null
  
)

export default component.exports